module.exports = __webpack_public_path__ + "static/fonts/Mont-SemiBold.5cf16df.ttf";